import { render, staticRenderFns } from "./OrganismPolicy.vue?vue&type=template&id=3cf2180b&scoped=true&"
import script from "./OrganismPolicy.vue?vue&type=script&lang=js&"
export * from "./OrganismPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OrganismPolicy.vue?vue&type=style&index=0&id=3cf2180b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2180b",
  null
  
)

export default component.exports